import Header from './components/Header';
import Hero from './components/Hero';
import UpdatesSection from './components/UpdatesSection';
import AppSection from './components/AppSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import FaqSection from './components/FaqSection';
import CommentsSection from './components/CommentsSection';
import CardsSection from './components/CardsSection';
import RankingSection from './components/RankingSection';
import AboutSection from './components/AboutSection';
import TopicsSection from './components/TopicsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <UpdatesSection />
        <AppSection />
        <MediaSection />
        <FeaturesSection />
        <IndexSection />
        <ContactSection />
        <CarouselSection />
        <FaqSection />
        <CommentsSection />
        <CardsSection />
        <RankingSection />
        <AboutSection />
        <TopicsSection />
      </main>
      <Footer />
    </>
  );
}